export const VOUCHER_TERMS = [
  "Both vouchers are valid for 12 months from the date of issue.",
  "Cash vouchers can be used at all Natureland outlets.",
  "Service vouchers can be used at all outlets except Marina Bay Sands, Jewel Changi Airport, and Changi Airport T2 Transit.",
  "Both voucher types are applicable for non-member rates only and non-refundable.",
  "Service vouchers cannot be used to redeem services or durations of a higher value.",
  "A valid 16-digit voucher code or QR code must be presented at the time of redemption.",
  "The management reserves the right to amend the terms and conditions without prior notice.",
  "Voucher cannot be used for online bookings. Please call the outlet to redeem.",
];
